import axios from 'axios';
import Common from './Common';
export default {
    // getAll() {
    //     return axios.get(Common.api + 'seller-login');
    // },

    getCategory() {
        return axios.get(Common.api + 'category-list');
    },
    getCategoryDropdown() {
        return axios.get(Common.api + 'category-list-dropdown');
    },
    getCategoryName(id) {
        return axios.get(Common.api + 'get-cat-name/' + id);
    },
    getAffiliatorCommissionName(id) {
        return axios.get(Common.api + 'get-aff-reward/' + id);
    },
    saveCategory(data) {
        return axios.post(Common.api + 'sub-category-list', data);
    },
    getSubCategory(id) {
        return axios.get(Common.api + 'sub-category-list/' + id);
    },
    getAllAffiliatedProducts(id, i, layer) {
        return axios.get(Common.api + 'aff-list-for-queue-all/' + id + '/' + i + '/' + layer);
    },
    getTitle(data) {
        return axios.post(Common.api + 'valid-name-test', data)
    },
    create(data) {
        return axios.post(Common.api + 'upload-product', data);
    },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    },
    getNames(data) {
        return axios.post(Common.api + 'get-names-for-confs', data);
    }
}